export const BUTTON_LABELS = {
  copyIssueLink: 'Copy link',
  deleteIssue: 'Delete issue',
  issueActions: 'Issue actions',
  transferIssue: 'Transfer issue',
  convertToDiscussion: 'Convert to discussion',
  acknowledgeAndConvertToDiscussion: 'I understand, convert this issue',
  tryAgain: 'Try again',
  updateComment: 'Update comment',
  new: 'New issue',
  cancel: 'Cancel',
  submitIssueTitleEdit: 'Save',
  closePanel: 'Close panel',
  addIssueType: 'Add issue type',
  changeIssueType: 'Change issue type',
  changeType: 'Change type',
  editTitle: 'Edit',
  pinIssue: 'Pin issue',
  unpinIssue: 'Unpin issue',
  signUp: 'Sign up for free',
  signIn: 'Sign in to comment',
}
